export default "__VITE_ASSET__jArRyG0F__"